<template>
    <div id="new-visit">
        <div class="columns-wrapper">
            <div class="left-column">
                <div class="row">
                    <div class="label">
                        Wybierz miasto
                    </div>
                    <div class="input">
                        <label for="city-select" class="icon-container">
                            <img src="../../images/place-green.png">
                        </label>
                        <select id="city-select" class="select-default"
                                v-model="checkedCity"
                                :disabled="isDisabled(STEPS.CITY)">
                            <option :value="CHOOSE_CITY_PLACEHOLDER" disabled>
                                {{ CHOOSE_CITY_PLACEHOLDER }}
                            </option>
                            <option v-for="city in cities" :value="city">
                                {{ city }}
                            </option>
                        </select>
                    </div>
                </div>

                <!-- ASSUMPTION: ANY_SPECIALTY means specialty with specific id or no specialty at all! -->
                <div class="row">
                    <div class="label">
                        Wybierz specjalizację
                    </div>
                    <div class="input">
                        <label for="speciality-select" class="icon-container">
                            <img src="../../images/drill-green.png">
                        </label>
                        <select id="speciality-select" class="select-default"
                                v-model="checkedSpecialty"
                                :disabled="isDisabled(STEPS.SPECIALTY)"
                                :class="{'loading': isElementLoading(STEPS.SPECIALTY)}">
                            <option :value="CHOOSE_SPECIALTY_PLACEHOLDER" disabled>
                                {{ CHOOSE_SPECIALTY_PLACEHOLDER }}
                            </option>
                            <option :value="ANY_SPECIALTY_PLACEHOLDER">
                                {{ ANY_SPECIALTY_PLACEHOLDER }}
                            </option>
                            <option v-for="specialty in specialties" :value="specialty.id">
                                {{ specialty.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="label">
                        Wybierz lekarza
                    </div>
                    <div class="input">
                        <label for="doctor-select" class="icon-container">
                            <img src="../../images/doctor-green.png">
                        </label>
                        <select id="doctor-select" class="select-default"
                                v-model="checkedDoctor"
                                :disabled="isDisabled(STEPS.DOCTOR)"
                                :class="{'loading': isElementLoading(STEPS.DOCTOR)}">
                            <option v-if="!doctors.length && checkedDoctor === NO_DOCTORS_PLACEHOLDER"
                                    :value="NO_DOCTORS_PLACEHOLDER" disabled>
                                {{ NO_DOCTORS_PLACEHOLDER }}
                            </option>
                            <option v-else :value="CHOOSE_DOCTOR_PLACEHOLDER" disabled>
                                {{ CHOOSE_DOCTOR_PLACEHOLDER }}
                            </option>
                            <option v-if="doctors.length > 1" :value="ANY_DOCTOR_PLACEHOLDER">
                                {{ ANY_DOCTOR_PLACEHOLDER }}
                            </option>
                            <option v-for="doctor in doctors" :value="doctor.id">
                                {{ doctor.user.first_name }} {{ doctor.user.last_name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="middle-column">
                 <div class="row">
                    <div class="label">
                        Wybierz datę
                    </div>
                    <div class="input">
                        <label for="datepicker-start" class="icon-container">
                            <img src="../../images/calendar-green.png">
                        </label>
                        <input type="text" id="datepicker-start" class="date-input" v-model="dateStart"
                               :disabled="isDisabled(STEPS.DATE)" placeholder="Data od..." readonly>
                    </div>
                </div>
                <div class="row">
                    <div class="label">
                        Wybierz przedział godziny
                    </div>
                    <div class="input">
                        <label for="timepicker-start" class="icon-container">
                            <img src="../../images/clock-green.png">
                        </label>
                        <input id="timepicker-start" class="time-input" v-model="timeStart"
                               :disabled="isDisabled(STEPS.TIME)" placeholder="Godzina od...">
                        <input id="timepicker-end" class="time-input" v-model="timeEnd"
                               :disabled="isDisabled(STEPS.TIME)" placeholder="Godzina do...">
                    </div>
                </div>
                <button id="btn-search" class="btn-default btn-large" @click="findFreeTerms()" :disabled="isSearchDisabled"
                        :class="{'btn-solid-grey': isSearchDisabled, 'not-allowed': isSearchDisabled}">
                    <img src="../../images/lens.png">
                    <span id="btn-search-text">WYSZUKAJ TERMINY</span>
                </button>
            </div>
            <div class="right-column">
                <div id="departments-heading">
                    <div class="departments-icon">
                        <img src="../../images/department-green.png">
                    </div>
                    <span class="departments-text">Wybierz oddział</span>
                </div>
                <ul id="departments-list">
                    <li :class="{'loading': isElementLoading(STEPS.DEPARTMENTS)}"></li>
                    <li v-for="department in departments">
                        <input type="checkbox" name="departments" class="checkbox-green" v-model="checkedDepartments"
                               :id="`department-${department.id}`" :value="department.id">
                        <label :for="`department-${department.id}`">{{ department.name }}</label>
                    </li>
                    <li class="empty-departments journal-text" v-if="!departments.length">
                        Najpierw wybierz miasto i specjalność...
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import "../../css/colors.scss";

$icon-container-width: 70px;
$btn-search-color: #77c497;
$new-visit-txt-color: #7bc697;
$date-time-input-border-color: #708090;

#new-visit {
    display: flex;
    flex-flow: column;
    max-width: 1000px;
    margin: 0 auto;

    .columns-wrapper {
        margin: 0 auto;
        width: 100%;
        max-width: 1000px;
        display: flex;
        flex-flow: row;
        color: $new-visit-txt-color;

        .left-column,
        .middle-column {
            flex-basis: calc(100% / 3);

            .row {
                margin-top: 0.5em;

                .label {
                    font-size: 17.5px;
                    padding-left: $icon-container-width;
                }
                .input {
                    display: flex;
                    align-items: center;
                    min-height: 54px;

                    .icon-container {
                        width: $icon-container-width;
                        display: inline-block;
                        text-align: center;
                    }
                    .date-input,
                    .time-input {
                        width: 95px;
                        text-align: center;
                        border-radius: 15px;
                        border: 1px solid $date-time-input-border-color;
                        height: 38px;
                        outline: none;
                        -webkit-appearance: none;
                    }
                    .date-input {
                        padding-left: 15px;
                        text-align: left;
                        width: 185px;
                    }
                    #datepicker-start,
                    #timepicker-start {
                        margin-right: 8px;
                    }
                }
            }
        }
        .middle-column {
            max-width: 300px;
            margin-left: 1%;
        }
        .right-column {
            flex-basis: calc(100% / 3);
            display: flex;
            flex-direction: column;

            #departments-heading {
                display: flex;
                align-items: center;

                .departments-icon {
                    width: $icon-container-width;
                    display: inline-block;
                    text-align: center;
                }
                .departments-text {
                    font-size: 20px;
                    margin-top: 10px;
                }
            }
            #departments-list {
                flex-grow: 1;
                color: $dark-grey;

                li:not(:last-child) {
                    margin-bottom: 5px;
                }
                .empty-departments {
                    font-size: 20px;
                    margin-left: 1.5em;
                }
            }
        }
        select {
            max-width: 220px;
        }
    }
    #btn-search {
        display: flex;
        align-items: center;
        max-width: 250px;
        margin-top: 25px;
        margin-left: auto;
        margin-right: auto;
        background-color: $btn-search-color;

        &:hover {
            background-color: darken($btn-search-color, 10%);
        }
        #btn-search-text {
            font-size: 17px;
            width: 100%;
            line-height: 100%;
            vertical-align: middle;
            padding-left: 0.5em;
        }
    }
    @media all and (max-width: 875px) {
        min-width: 340px;

        .columns-wrapper {
            flex-direction: column;

            .left-column {
                order: 1;
            }
            .middle-column {
                order: 3;
            }
            .right-column {
                order: 2;
                margin-top: 30px;

            }
            select {
                max-width: 60%;
            }
        }
        #btn-search {
            max-width: initial;
            width: 100% !important;
            margin-top: 1.5em;
        }
    }
}
</style>

<script>
import ApiMixin from '../mixins/ApiMixin.js'

import {
    CHOOSE_CITY_PLACEHOLDER,
    CHOOSE_SPECIALTY_PLACEHOLDER,
    CHOOSE_DOCTOR_PLACEHOLDER,

    NO_DOCTORS_PLACEHOLDER,

    ANY_SPECIALTY_PLACEHOLDER,
    ANY_DOCTOR_PLACEHOLDER,

    NEW_VISIT_STEPS as STEPS,

    DATE_PICKER_CONFIG,
    TIME_PICKER_CONFIG,
} from '../constants.js'
import {
    getCurrentDate,
    getCurrentTime,
} from '../utils.js'

export default {
    name: 'NewVisit',
    mixins: [
        ApiMixin,
    ],
    data() {
        return {
            /* Holders for data returned from API. */

            cities: [],
            specialties: [],
            specialtiesById: {},
            departments: [],
            doctors: [],
            freeTerms: [],


            /* Component v-models. */

            checkedCity: CHOOSE_CITY_PLACEHOLDER,
            checkedSpecialty: CHOOSE_SPECIALTY_PLACEHOLDER,
            checkedDoctor: CHOOSE_DOCTOR_PLACEHOLDER,

            dateStart: getCurrentDate(),

            timeStart: getCurrentTime(),
            timeEnd: getCurrentTime(false).add(1, 'hours').format('HH:mm'),

            checkedDepartments: [],


            /* Constants. */

            STEPS: STEPS, // Planning new visit flow steps.

            CHOOSE_CITY_PLACEHOLDER: CHOOSE_CITY_PLACEHOLDER,
            CHOOSE_SPECIALTY_PLACEHOLDER: CHOOSE_SPECIALTY_PLACEHOLDER,
            CHOOSE_DOCTOR_PLACEHOLDER: CHOOSE_DOCTOR_PLACEHOLDER,

            NO_DOCTORS_PLACEHOLDER: NO_DOCTORS_PLACEHOLDER,

            ANY_SPECIALTY_PLACEHOLDER: ANY_SPECIALTY_PLACEHOLDER,
            ANY_DOCTOR_PLACEHOLDER: ANY_DOCTOR_PLACEHOLDER,


            /* Others. */

            currentStep: STEPS.CITY, // Current step of the planning flow.
            loadingElement: STEPS.CITY, // Designes which element is loading now.
            cacheHasBeenLoaded: false, // IMPORTANT VARIABLE: indicates whether the old state has been loaded.
        }
    },
    computed: {
        isSearchDisabled() {
            return this.currentStep !== STEPS.SEARCH;
        },
        isCacheAvailable() {
            return !!this.$store['NewVisit-cache'];
        },
        areWatchesMuted() {
            // VERY IMPORTANT: this computed property indicates whether visit planner inputs should be watched.
            // It's done like that because if we want to load old state of the component, we have to stop watches
            // for a moment, to prevent new data being loaded, which would overwrite previously loaded cached data.
            return this.isCacheAvailable && !this.cacheHasBeenLoaded;
        },
        noConstantComponentDataProperties() {
            // Also the 'cacheHasBeenLoaded' property is filtered.
            return Object.keys(this.$data).filter(key => key !== key.toUpperCase() && key !== 'cacheHasBeenLoaded');
        },
    },
    watch: {
        checkedCity(newVal) {
            if (this.areWatchesMuted) {return;}
            this.checkedSpecialty = null; // To trigger checkedSpecialty watch.
            this.specialties = [];
            this.departments = [];
            this.checkedDepartments = [];
            this.doctors = [];


            if (newVal && newVal !== CHOOSE_CITY_PLACEHOLDER) {
                this.loadingElement = this.STEPS.SPECIALTY;
                const url = this.$api.facility.detailSpecialtiesForCity(this.$app.$facility, newVal);

                this.$http.get(url).then(response => {
                    this.loadingElement = null;
                    this.specialties = response.data;
                    this.currentStep = this.STEPS.SPECIALTY;

                    this.checkedSpecialty = ANY_SPECIALTY_PLACEHOLDER;

                    // Make object from specialties list for a quick access by id.
                    this.specialtiesById = this.specialties.reduce((obj, el) => ({...obj, [el.id]: el}), {});
                });
            }
        },
        checkedSpecialty() {
            if (this.areWatchesMuted) {return;}
            this.doctors = [];
            this.departments = this.getDepartments();
            this.checkedDepartments = this.departments.length === 1 ? [this.departments[0].id] : [];
        },
        checkedDepartments(newVal) {
            if (this.areWatchesMuted) {return;}
            this.doctors = [];
            const specialty = this.checkedSpecialty === ANY_SPECIALTY_PLACEHOLDER ? null : this.checkedSpecialty;

            if (newVal.length) {
                this.loadingElement = this.STEPS.DOCTOR;
                this.doctors = [];
                const url = this.$api.facility.detailDoctors(this.$app.$facility, specialty, newVal);

                this.$http.get(url).then(response => {
                    this.loadingElement = null;
                    this.doctors = response.data;
                    this.currentStep = STEPS.DOCTOR;

                    // Check if there's only one doctor to choose or if there's no doctors
                    // at all then just set this.doctor = NO_DOCTORS_PLACEHOLDER.
                    if (!this.doctors.length) {
                        this.checkedDoctor = NO_DOCTORS_PLACEHOLDER;
                    } else if (this.doctors.length === 1) {
                        this.checkedDoctor = this.doctors[0].id;
                        this.currentStep = this.STEPS.SEARCH;
                    } else {
                        this.checkedDoctor = CHOOSE_DOCTOR_PLACEHOLDER;
                    }
                });
            } else {
                this.checkedDoctor = NO_DOCTORS_PLACEHOLDER;
                this.currentStep = STEPS.DOCTOR;
            }
        },
        checkedDoctor(newVal) {
            if (newVal !== CHOOSE_DOCTOR_PLACEHOLDER && newVal !== NO_DOCTORS_PLACEHOLDER)
                this.currentStep = this.STEPS.SEARCH;
        },
        timeStart(newVal) {
            if (newVal > this.timeEnd) {
                let tempTime = newVal.split(':');
                tempTime[0]++;
                this.timeEnd = tempTime.join(':');
            }
        }
    },
    methods: {
        loadComponentState() {
            // Load all not constant properties from the component cache.
            this.noConstantComponentDataProperties.forEach(property => {
                this[property] = this.$store['NewVisit-cache'][property];
            });
        },
        saveComponentState() {
            // Save all component data in the store.
            this.$bus.$emit('$store:setNewVisit-cache', this.$data);
        },
        loadCities() {
            // Load available cities for facility.
            this.$app.showLoader();
            const url = this.$api.facility.detailCities(this.$app.$facility);

            this.$http.get(url).then(response => {
                this.cities = response.data;
                this.loadingElement = null;

                // Check if there's only one checkedCity to choose.
                if (this.cities.length === 1)
                    this.checkedCity = this.cities[0];

                this.$app.hideLoader();
            });
        },
        findFreeTerms(last_shown_term) {
            this.$app.showLoader();
            if (!last_shown_term) { // if last_term is given, it means that list of free terms is being expanded
                this.freeTerms = [];
            }
            const specialty = this.checkedSpecialty === ANY_SPECIALTY_PLACEHOLDER ? null : this.checkedSpecialty;
            const doctor = this.checkedDoctor === ANY_DOCTOR_PLACEHOLDER ? null : this.checkedDoctor;
            const dateStart = last_shown_term ? last_shown_term.date: this.dateStart;
            const last_shown_term_params = last_shown_term ? last_shown_term.date + 'T' +last_shown_term.timeFrom : null;
            const url = this.$api.visit.listFreeTerms(
                specialty,
                doctor,
                this.checkedDepartments,
                dateStart,
                this.timeStart,
                this.timeEnd,
                last_shown_term_params,
            );

            return this.$http.get(url).then(response => {
                let newTerms = response.data.filter(this.shouldTermBeShown).map(freeTerm => {
                    return {...freeTerm, specialty: this.specialtiesById[this.checkedSpecialty]};
                });
                this.freeTerms.push(...newTerms);
                if (!newTerms.length) { // no more free terms, hide button
                    this.$bus.$emit('moreAvailableTerms', false);
                }
                this.$bus.$emit('$store:setFreeTermsList', this.freeTerms);
                if (!last_shown_term) {
                    this.$router.push({name: 'free-terms-list'});
                }
                this.$app.hideLoader();
            });

        },
        isElementLoading(step) {
            return step === this.loadingElement;
        },
        isDisabled(input) {
            if (input === this.STEPS.SPECIALTY)
                return this.currentStep === this.STEPS.CITY;

            // If no departments checked at the doctor step, keep doctor input disabled.
            if (input === this.STEPS.DOCTOR)
                return !this.checkedDepartments.length;

            if (input === this.STEPS.DATE || input === this.STEPS.TIME)
                return this.checkedDoctor === CHOOSE_DOCTOR_PLACEHOLDER
                    || this.checkedDoctor === NO_DOCTORS_PLACEHOLDER;

            return false;
        },
        getDepartments() {
            // Get departments from the store.
            if (!this.checkedSpecialty || this.checkedSpecialty === CHOOSE_SPECIALTY_PLACEHOLDER)
                return [];

            // Filter departments depending on chosen city and specialty.
            let departments = this.$store.departmentsList.filter(elem => elem.city === this.checkedCity);

            if (this.checkedSpecialty !== ANY_SPECIALTY_PLACEHOLDER)
                departments = departments.filter(elem => ~elem.specialties.indexOf(this.checkedSpecialty));

            return departments;
        },
        initDatePickers() {
            $.datepicker.regional['pl'] = DATE_PICKER_CONFIG;
            $.datepicker.setDefaults($.datepicker.regional['pl']);
            let maxPatientVisitSearchRange = this.$store.maxPatientVisitSearchRange;
            let maxDate = moment().add(maxPatientVisitSearchRange, 'day');
            $('#datepicker-start').datepicker({
                dateFormat: 'yy-mm-dd',
                minDate: new Date(),
                onSelect: dateText => this.dateStart = dateText,
                beforeShowDay: function(date) {
                    if (maxDate <= date) {
                        // [is_selectable, additional css class, tooltip]
                        return [false, '', 'Placówka pozwala na rezerwację terminu z maksymalnym wyprzedzeniem ' +
                        maxPatientVisitSearchRange + ' dni.'];
                    } else {
                         return [true, '', ''];
                    }
                }
            });
        },
        initTimePickers() {
            const timePickerStart = $('#timepicker-start').timepicker({
                timeFormat: 'H:i',
                step: TIME_PICKER_CONFIG.STEP,
                maxTime: '23:45',
                disableTextInput: true
            }).timepicker('setTime', this.timeStart);

            const timePickerEnd = $('#timepicker-end').timepicker({
                timeFormat: 'H:i',
                step: TIME_PICKER_CONFIG.STEP,
                maxTime: '23:45',
                disableTextInput: true
            }).timepicker('setTime', this.timeEnd);

            timePickerStart.on('changeTime', () => {
                this.timeStart = timePickerStart.timepicker('getTime').toTimeString().slice(0, 5);
            });
            timePickerEnd.on('changeTime', () => {
                this.timeEnd = timePickerEnd.timepicker('getTime').toTimeString().slice(0, 5);
            });
        },
        shouldTermBeShown(newTerm) {
            const exists = this.freeTerms.some((term) => {
                return (newTerm.date === term.date && newTerm.timeFrom === term.timeFrom
                    && newTerm.timeTo === term.timeTo && newTerm.doctor === term.doctor)
            });
            return !exists;
        },
    },
    created() {
        if (this.isCacheAvailable) {
            this.loadComponentState();
            // $nextTick function usage is necessary here, we have to give some
            // time to trigger watches for the very first time and mute them.
            this.$nextTick(() => this.cacheHasBeenLoaded = true);
        } else {
            this.loadCities();
        }
    },
    mounted() {
        this.initDatePickers();
        this.initTimePickers();
        this.$bus.$on('getNextFreeTerms', last_shown_term => {
            this.findFreeTerms(last_shown_term).then(() => {
                this.$nextTick(() => {
                    // Every time terms list is appended nicescroll needs to be told to recalculate its stuff
                    $('body').getNiceScroll().resize();
                })
            });
        });
    },
    beforeDestroy() {
        this.saveComponentState();
    },
}
</script>



// WEBPACK FOOTER //
// NewVisit.vue?db0b541c